// [PHASE B / #020 — string-sin batch 2]: Build the buff descriptor that
//   travels with a quickcast spell to a targeted ally. Pre-fix App.jsx
//   dispatched on `quickcastSpell.name === 'Bless' / 'Guidance' /
//   'Enhance Ability'` to figure out whether the ally should track an
//   advantage flag and/or a +1d4-style dice bonus. That hardcoded D&D 5e
//   spell names into the engine — the long-term data-block vision
//   (`feedback_long_term_data_block_vision.md`) requires the spell row
//   itself to declare its mechanical effect.
//
// Schema:
//
//   spell.appliedEffect = {
//     advantage?: boolean,   // ally tracks advantage on the targeted roll
//     bonus?: string,        // ally tracks a dice-string bonus (e.g. '1d4')
//   }
//
// Both fields are optional. A spell that declares neither (or has no
// `appliedEffect`) produces the no-op payload `{ advantage: false, bonus: null }`.
//
// Per Rule 22, this is the single source of truth for the ally-buff
// payload shape. Both App.jsx call sites import it; the test imports
// the same module. Adding a new field (e.g. `damage`, `condition`) is
// a one-place edit + one-place test addition.

/**
 * Produce the ally-buff payload for a quickcast spell.
 *
 * @param {object|null|undefined} spell - The quickcast spell row
 *   (from srdSpells or a CW-authored custom spell).
 * @returns {{ advantage: boolean, bonus: string|null }}
 */
export function buildAllyBuffPayload(spell) {
  const applied = spell && typeof spell === 'object' ? spell.appliedEffect : null;
  if (!applied || typeof applied !== 'object') {
    return { advantage: false, bonus: null };
  }
  return {
    advantage: !!applied.advantage,
    bonus: typeof applied.bonus === 'string' && applied.bonus ? applied.bonus : null,
  };
}
